import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import NativeTable from '../../../../components/NativeTable/NativeTable';
import { Alert, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Loader from '../../../../components/Loader/Loader';
import { createWebsite, updateWebsite, deleteWebsite } from '../../../../actions/settings';

import screen from '../CustomerScreen.module.scss';
import { withTranslation } from '../../../../i18n/LanguageContext';

class WebSites extends React.Component {

    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };

    state = {
        isAddModal: false,
        deleteAssetId: null,
        siteUrl: "",
        siteName: "",
        curSite: null,
        siteError: "",
        editError: ""
    };

    constructor() {
        super();

        this.changeName = this.changeName.bind(this);
        this.changeUrl = this.changeUrl.bind(this);
        this.changeEditSiteName = this.changeEditSiteName.bind(this);
        this.changeEditSiteUrl = this.changeEditSiteUrl.bind(this);
        this.apiFormatter = this.apiFormatter.bind(this);
    }

    changeName(event) {
        this.setState({ siteName: event.target.value, siteError: "" });
    }

    changeUrl(event) {
        this.setState({ siteUrl: event.target.value, siteError: ""  });
    }

    changeEditSiteName(event) {
        var curSite = this.state.curSite;
        curSite.Name = event.target.value;
        this.setState({ curSite: curSite, editError: "" });
    }

    changeEditSiteUrl(event) {
        var curSite = this.state.curSite;
        curSite.Url = event.target.value;
        this.setState({ curSite: curSite, editError: "" });
    }

    onClickSaveSite = (e) => {
        e.preventDefault();

        var siteError = "";
        const {siteName, siteUrl} = this.state;

        if (siteName == "") {
            siteError = "Please input a site name";
        } else if (siteUrl == "") {
            siteError = "Please input a site url";
        }

        if (siteError == "") {
            this.props.dispatch(createWebsite({
                AssetName: siteName,
                Url: siteUrl
            }))
        }
        this.setState({siteError: siteError});
    }

    onClickUpdate = (event) => {
        event.preventDefault();

        const { curSite } = this.state;

        var editError = "";
        if (curSite.Name == "") {
            editError = "Please input the website name";
        }

        if (curSite.Url == "") {
            editError = "Please input the website url";
        }

        if (editError == "") {
            this.props.dispatch(updateWebsite({
                AssetId: curSite.AssetId,
                AssetName: curSite.Name,
                Url: curSite.Url
            }));
            this.setState({isAddModal: false});
        } else {
            this.setState({editError: editError});
        }
    }

    editSite (id) {
        const site = this.getSiteById(id);
        this.setState({isAddModal: true, curSite: site});
    }

    getSiteById = (id) => {
        const {websites} = this.props;
        var data = websites.filter(function( w ) {
            return w.AssetId == id;
        });

        var site = null;
        if (data.length > 0) {
            site = {... data[0]};
        }
        return site;
    }

    removeSite(id) {
        this.closeDeleteModal();
        this.props.dispatch(deleteWebsite(id));
    }

    closeEditModal = () => {
        this.setState({isAddModal: false, editError: ""});
    }

    openDeleteModal = (assetId) => {
        this.setState({ deleteAssetId: assetId });
    }

    closeDeleteModal = () => {
        this.setState({ deleteAssetId: null });
    }

    apiFormatter(cell, row) {
        return (
            <div className={screen.cardActions}>
                <button
                    type="button"
                    className={screen.secondaryBtn}
                    onClick={() => this.editSite(row.AssetId)}
                >
                    {this.props.t('common.edit')}
                </button>
                <button
                    type="button"
                    className={screen.dangerBtn}
                    onClick={() => this.openDeleteModal(row.AssetId)}
                    disabled={this.props.isDeleting && this.props.idToDelete === row.AssetId}
                >
                    {this.props.isDeleting && this.props.idToDelete === row.AssetId ? <Loader size={14}/> : this.props.t('common.delete')}
                </button>
            </div>
        );
    }

    render() {
        const { t } = this.props;
        const {curSite, siteError, siteName, siteUrl, editError, isAddModal, deleteAssetId} = this.state;
        const { websites } = this.props;
        const deleteSiteRow = deleteAssetId != null ? this.getSiteById(deleteAssetId) : null;

        return (
            <div className={screen.sectionCard}>
                <div className={screen.sectionCardHeader}>{t('customerScreen.urls')}</div>
                <div className={screen.sectionCardBody}>
                    <p className={screen.noteText}>{t('customerScreen.urlsIntro')}</p>
                    <form onSubmit={this.onClickSaveSite}>
                        <div className={screen.fieldGrid}>
                            <div className={screen.field}>
                                <label htmlFor="customer-screen-site-url">{t('customerScreen.websiteUrl')}</label>
                                <input
                                    id="customer-screen-site-url"
                                    type="text"
                                    className="form-control"
                                    placeholder="www.example.com"
                                    value={siteUrl}
                                    onChange={this.changeUrl}
                                />
                            </div>
                            <div className={screen.field}>
                                <label htmlFor="customer-screen-site-name">{t('customerScreen.websiteName')}</label>
                                <input
                                    id="customer-screen-site-name"
                                    type="text"
                                    className="form-control"
                                    placeholder="Example"
                                    value={siteName}
                                    onChange={this.changeName}
                                />
                            </div>
                        </div>
                        {siteError ? (
                            <Alert className="alert-sm" color="danger">{siteError}</Alert>
                        ) : null}
                        <button type="submit" className={screen.primaryBtn}>{t('customerScreen.saveUrl')}</button>
                    </form>
                    <div className={screen.tableWrap}>
                        <NativeTable
                            data={websites}
                            columns={[
                                { key: 'Name', header: t('common.name') },
                                { key: 'Url', header: t('customerScreen.url') },
                                { key: 'AssetId', header: '', render: (cell, row) => this.apiFormatter(cell, row) },
                            ]}
                        />
                    </div>
                </div>
                <Modal isOpen={isAddModal} toggle={this.closeEditModal} modalClassName={screen.darkModal}>
                    <ModalHeader toggle={this.closeEditModal}>{t('customerScreen.editWebsite')}</ModalHeader>
                    <ModalBody>
                        {editError ? (
                            <Alert className="alert-sm" color="danger">{editError}</Alert>
                        ) : null}
                        {curSite ? (
                            <div>
                                <div className={screen.field}>
                                    <label htmlFor="customer-screen-edit-site-name">{t('customerScreen.websiteName')}</label>
                                    <input
                                        id="customer-screen-edit-site-name"
                                        type="text"
                                        className="form-control"
                                        value={curSite.Name}
                                        onChange={this.changeEditSiteName}
                                    />
                                </div>
                                <div className={`${screen.field} mt-3`}>
                                    <label htmlFor="customer-screen-edit-site-url">{t('customerScreen.url')}</label>
                                    <input
                                        id="customer-screen-edit-site-url"
                                        type="text"
                                        className="form-control"
                                        value={curSite.Url}
                                        onChange={this.changeEditSiteUrl}
                                    />
                                </div>
                            </div>
                        ) : null}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" outline onClick={this.closeEditModal}>{t('common.cancel')}</Button>
                        <Button color="primary" onClick={this.onClickUpdate}>{t('common.update')}</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={deleteAssetId != null} toggle={this.closeDeleteModal} modalClassName={screen.darkModal}>
                    <ModalHeader toggle={this.closeDeleteModal}>{t('customerScreen.deleteUrl')}</ModalHeader>
                    <ModalBody>
                        {deleteSiteRow
                            ? t('customerScreen.deleteUrlNamed', { name: deleteSiteRow.Name })
                            : t('customerScreen.deleteUrlBody')}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" outline onClick={this.closeDeleteModal}>{t('common.cancel')}</Button>
                        <Button
                            color="danger"
                            onClick={() => this.removeSite(deleteAssetId)}
                            disabled={this.props.isDeleting}
                        >
                            {this.props.isDeleting ? <Loader size={14}/> : t('common.delete')}
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        websites: state.settings.websites,
        isReceiving: state.settings.isReceiving,
        isUpdating: state.settings.isUpdating,
        isDeleting: state.settings.isDeleting,
        idToDelete: state.settings.idToDelete,
    };
}

export default withRouter(connect(mapStateToProps)(withTranslation(WebSites)));
